import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@pitchero/react-ui';
import { Trans } from '../../../lib/i18n';

const MobileAppPromo = ({ link, style }) => (
  <Typography preset="body--small" align="center" component="div" style={style}>
    <Trans common="teams:mobile_app_promo">
      View the latest match information with the new Club App:&nbsp;
      <Typography preset="subtitle--small" color="primary" component="a" href={link}>
        Available on iOS & Android
      </Typography>
      .
    </Trans>
  </Typography>
);

MobileAppPromo.defaultProps = {
  style: {},
};

MobileAppPromo.propTypes = {
  link: PropTypes.string.isRequired,
  style: PropTypes.shape(),
};

export default MobileAppPromo;
